var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "DyQuillEditor" } },
    [
      _c("el-upload", {
        ref: "fileUpload",
        staticClass: "avatarUploader",
        attrs: {
          action: _vm.baseUrl + "/api/v1/file/upload?biztype=" + _vm.biztype,
          "show-file-list": false,
          "on-success": _vm.handleUploadSuccess,
        },
      }),
      _vm._v(" "),
      _c("quill-editor", {
        ref: "quillEditorRef",
        attrs: { options: _vm.options, "content-type": "html" },
        on: {
          blur: function ($event) {
            return _vm.onEditorBlur($event)
          },
          focus: function ($event) {
            return _vm.onEditorFocus($event)
          },
          change: function ($event) {
            return _vm.onEditorChange($event)
          },
        },
        model: {
          value: _vm.content,
          callback: function ($$v) {
            _vm.content = $$v
          },
          expression: "content",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }